import {
  useAxios,
  useHandleApiError,
} from '@sttedra_ui/framework';

import RouteDetailsApiResponseModel from './route-details.api-response-model.js';

// #region Globals
const {base} = useAxios();
const INFO_ROUTE_BASE_PATH = 'rutainfo';
const ROUTE_GEOJSON_BASE_PATH = 'rutageojson';
const DEFAULT_TIMEOUT = 0; // ms
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions
async function getRouteGeoJson(points = [], shortestRoute = false, throwError = true) {
  try {
    const url = '/' + ROUTE_GEOJSON_BASE_PATH;
    const postRequest = {
      poblaciones: points,
      mode: shortestRoute ? 'distance' : 'Time',
    };
    const {
      data,
    } = await base.post(url, postRequest, {
      timeout: DEFAULT_TIMEOUT,
    });
    const {geojson: feature, bbox: extent} = data;
    return {
      feature,
      extent,
    };
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}
async function getRouteDetails(points = [], shortestRoute = false, throwError = true) {
  try {
    const url = '/' + INFO_ROUTE_BASE_PATH;
    const postRequest = {
      poblaciones: points,
      mode: shortestRoute ? 'distance' : 'Time',
    };
    const {
      data: originalData,
      'total_distance': totalDistance2,
      'total_time': totalTime2,
    } = await base.post(url, postRequest, {
      timeout: DEFAULT_TIMEOUT,
    });
    const bannedPois = [];
    const data = [];
    const origData = originalData.data;
    let nseq = null;
    let npois = [];
    for (const s of origData) {
      nseq = new RouteDetailsApiResponseModel(s);
      nseq.poiList = nseq.poiList.filter((p) => !bannedPois.find((id) => p.id === id));
      data.push(nseq);
      npois = nseq.poiList.map((p) => p.id);
      bannedPois.push(...npois);
    }
    let [routeTime, routeDistance] = [0, 0];
    for (const seq of data) {
      routeTime += seq.time;
      routeDistance += seq.distance;
      seq.routeTime = routeTime;
      seq.routeDistance = routeDistance;
    }
    return {
      totalTime2,
      totalDistance2,
      totalTime: routeTime,
      totalDistance: routeDistance,
      route: data,
    };
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}
// #endregion

// #region Private functions
// ...
// #endregion

export {
  getRouteDetails,
  getRouteGeoJson,
};
